import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=10c34034&"
import script from "./AppHeader.js?vue&type=script&lang=js&"
export * from "./AppHeader.js?vue&type=script&lang=js&"
import style0 from "./AppHeader.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports